import React, { Component, Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useTexture, Edges, Float, ContactShadows } from '@react-three/drei';
import * as THREE from 'three';

const DEFAULT_TEXTURE = '/marble-white-galaxy.jpg';

function Slab({ url }) {
  const texture = useTexture(url);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 8;
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1.4, 1.4);
  return (
    <Float speed={1.4} rotationIntensity={0.22} floatIntensity={0.8}>
      <mesh>
        <boxGeometry args={[3.3, 2.1, 0.35]} />
        <meshStandardMaterial map={texture} roughness={0.2} metalness={0.18} />
        <Edges scale={1.015} color="#D4AF37" />
      </mesh>
    </Float>
  );
}

class SlabErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="w-full h-full border border-[#D4AF37]/30 overflow-hidden">
          <img src={this.props.fallback || DEFAULT_TEXTURE} alt="Premium marble slab" className="w-full h-full object-cover" />
        </div>
      );
    }
    return this.props.children;
  }
}

export default function MarbleSlab3D({ texture = DEFAULT_TEXTURE }) {
  return (
    <SlabErrorBoundary fallback={texture}>
      <Canvas camera={{ position: [0, 0.5, 4.6], fov: 42 }} dpr={[1, 2]} data-testid="marble-slab-canvas">
        <ambientLight intensity={0.55} />
        <directionalLight position={[4, 6, 4]} intensity={1.5} color="#FFF3D6" />
        <spotLight position={[-5, 4, 3]} intensity={1.2} color="#D4AF37" angle={0.5} penumbra={0.8} />
        <Suspense fallback={null}>
          <Slab key={texture} url={texture} />
        </Suspense>
        <ContactShadows position={[0, -1.7, 0]} opacity={0.55} blur={2.6} color="#000000" />
        <OrbitControls
          autoRotate
          autoRotateSpeed={1.4}
          enableZoom={false}
          enablePan={false}
          minPolarAngle={Math.PI / 3.2}
          maxPolarAngle={Math.PI / 1.7}
        />
      </Canvas>
    </SlabErrorBoundary>
  );
}
